import { observable, action, computed, runInAction, decorate } from 'mobx';
import agent from '../api/agent';
import { IRequestReview, IRequestReviewCreateForm, IRequestReviewSubmitForm } from '../models/RequestReview';
import { toast } from 'react-toastify';
import { history } from '../../indexMsal';
import { RootStore } from './RootStore';
import React from 'react';
import RequestReviewNoteCompleteForm from '../../Features/requests/review/form/notes/RequestReviewNoteCompleteForm';
import { noteTypes } from '../enumerable/NoteTypes';
import RequestReviewMakeDetermination from '../../Features/requests/review/form/steps/RequestReviewMakeDetermination';
import { IRequestReviewValidation, IRequestReviewValidationForm } from '../models/RequestReviewValidation';
import RequestReviewSubmitConfirmation from '../../Features/requests/review/form/steps/RequestReviewSubmitConfirmation';
import RequestReviewValidation from '../../Features/requests/review/form/steps/RequestReviewValidation';

//const LIMIT = 10;

export default class RequestReviewStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    // reaction(
    //   () => this.predicate.keys(),
    //   () => {
    //     this.page = 0;
    //     this.RequestReviewRegistry.clear();
    //     this.loadRequestReviews();
    //   }
    // )
  }

  requestResult: string | undefined;
  validating: boolean = false;
  validatedResult: boolean = false;
  submitedNote: boolean = false;
  RequestReviewRegistry = new Map();
  RequestReview: IRequestReview | null = null;
  loadingInitial = false;
  submitting = false;
  target = "";
  limit = 10;
  totalPages = 0;
  sortBy = 'Request.RequestDate';
  sortOrder = 'descending' as 'ascending'|'descending'| undefined;
  availableReviewResults: string[] | undefined;
  ValidationResult: IRequestReviewValidation | undefined;
  pdf = "";
  requestReviewCount = 0;
  page = 0;
  predicate = new Map();

  setPredicate = async (predicate: string, value: string | Date) => {
    // if(this.quickFilters.includes(predicate)){
    //     this.predicate.clear();
    //     if (predicate !== 'all') {
    //         this.predicate.set(predicate, value);
    //     }
    //     this.RequestRegistry.clear();
    // }
    // else{
    //     this.predicate.set(predicate, value);
    //     this.RequestRegistry.clear();
    // }

    this.predicate.set(predicate, value);
    this.page = 0;
    this.RequestReviewRegistry.clear();
    await this.loadTableRequestReviews();


  }

  get axiosParams() {
    const params = new URLSearchParams();
    params.append('limit', String(this.limit));
    params.append('offset', `${this.page ? this.page * this.limit : 0}`);
    params.append('sortBy', `${this.sortBy}`);
    params.append('sortOrder', `${this.sortOrder==='ascending'?'asc':'desc'}`);
    this.predicate.forEach((value, key) => {
      if (key === 'startDate') {
        params.append(key, value.toISOString);
      } else {
        params.append(key, value);
      }
    })
    return params;
  }
  incrementRequestReviewNote = (id: string) => {
    let review = this.RequestReview
    review!.noteCount += 1;
  }

  setSort = (sortOrder: 'ascending'| 'descending'|undefined, sortBy:string) => {
    this.sortOrder = sortOrder;
    this.sortBy = sortBy;
    // await this.loadTableRequests();
  }
  setLimit = (limit: number) => {
    this.limit = limit;
    this.setPage(0)
  }



  setPage = (page: number) => {
    this.page = page;
  }

  get requestReviewsByDate() {
    return Array.from(this.RequestReviewRegistry.values()).sort(
        (a, b) => b.submittedOn - a.submittedOn
    );
  };
  get requestReviews() {
    return Array.from(this.RequestReviewRegistry.values());
  };

  loadRequestReviews = async () => {
    this.loadingInitial = true;
    try {
      const requestReviewsEnvelope = await agent.RequestReviews.list(this.axiosParams);
      const { requestReviewsDto, requestReviewCount } = requestReviewsEnvelope;

      runInAction('loadRequestReviews', () => {
        requestReviewsDto.forEach((requestReview) => {
          this.RequestReviewRegistry.set(requestReview.id, requestReview);
        });
        this.requestReviewCount = requestReviewCount;
      });

    } catch (error) {
      throw error;
    }
    runInAction('loadRequestReviews', () => {
      this.loadingInitial = false;
    });
  }
  loadTableRequestReviews = async () => {
    this.loadingInitial = true;
    try {
      const requestsEnvelope = await agent.RequestReviews.list(this.axiosParams);
      const { requestReviewsDto, requestReviewCount } = requestsEnvelope;
      this.RequestReviewRegistry.clear();
      runInAction('loadRequestReviews', () => {
        requestReviewsDto.forEach((request) => {
          // appeal.submittedOn=new Date(appeal.submittedOn);
          this.RequestReviewRegistry.set(request.id, request);
        });
        this.requestReviewCount = requestReviewCount;
        this.totalPages = Math.ceil(this.requestReviewCount / this.limit)
      });

    } catch (error) {
      throw error;
    }
    runInAction('loadRequestReviews', () => {
      this.loadingInitial = false;
    });
  };
  loadRequestReview = async (id: string) => {
    this.RequestReviewRegistry.clear();
    this.validatedResult = false;
    this.submitedNote = false;

    let RequestReview = this.getRequestReview(id);
    if (RequestReview) {
      this.RequestReview = RequestReview;
      return RequestReview;
    }
    else {
      this.loadingInitial = true;
      try {
        RequestReview = await agent.RequestReviews.details(id);

        runInAction('getting review ', () => {
          RequestReview.SubmittedOn = new Date(RequestReview.SubmittedOn);
          this.pdf = RequestReview.supportingFileByteStream;
          this.RequestReview = RequestReview;
          this.RequestReviewRegistry.set(RequestReview.appealId, RequestReview);
          this.loadingInitial = false;
        })
        return RequestReview;
      } catch (error) {
        history.push("/requests");
        toast.error('problem loading data');
      }
    }
    runInAction('loadReviews', () => {
      this.loadingInitial = false;
    });
  };

  getRequestReview = (id: string) => {
    return this.RequestReviewRegistry.get(id);
  };
  loadPDF = async (id: string | null) => {
    this.pdf = "loading"
    try {
      const RequestPDF = await agent.RequestPDF.details(id);
      runInAction('getting pdf', () => {
        this.pdf = RequestPDF.supportingFileByteStream;
      })

      return RequestPDF;
    } catch (error) {
      toast.error('problem loading pdf');
    }
  };

  clearRequestReviews = async () => {
    this.RequestReviewRegistry.clear();
  }
  clearRequestReviewData = () => {
    this.submitting = false;
    this.requestResult = undefined;
    this.validating = false;
    this.validatedResult = false;
    this.submitedNote = false;
    this.availableReviewResults = undefined;
    this.ValidationResult = undefined;
  }

  createRequestReview = async (requestId: string) => {
    this.submitting = true;
    var id: string = "";

    try {
      var requestReviewFormPost = new IRequestReviewCreateForm(undefined, requestId)
      const Response = await agent.RequestReviews.create(requestReviewFormPost);
      id = Response;

    } catch (error) {
      await this.rootStore.requestStore.loadRequests();
      toast.error('Problem Creating Review');
      throw error;
    }
    runInAction('createRequestReview', () => {
      this.submitting = false;
      this.clearRequestReviewData()
    });
    this.rootStore.modalStore.closeModal();
    history.push(`/RequestReview/${id}`)
  };

  SubmitRequestReview = async (requestForm: IRequestReviewSubmitForm) => {
    this.submitting = true;

    var id: string = "";

    try {
      const Response = await agent.RequestReviews.update(requestForm);
      id = Response;

    } catch (error) {
      toast.error('Problem Creating Review');
      throw error;
    }
    runInAction('createRequestReview', () => {
      this.submitting = false;

      //clear data
      this.availableReviewResults = undefined;
      this.ValidationResult = undefined;

      this.validating = false;
      this.validatedResult = false;
      this.requestResult = undefined

    });
    this.rootStore.modalStore.closeModal();
  };


  SubmitRequestValidation = async () => {
    var submitForm: IRequestReviewValidationForm = new IRequestReviewValidationForm(this.RequestReview?.requestId);
    try {
      const Response = await agent.RequestReviewValidation.validate(submitForm);
      this.ValidationResult = Response;
      this.validatedResult = Response.canSubmit
      this.availableReviewResults = Response.recomendedResults

    } catch (error) {

      console.log(error)
      if(error.data.errors != undefined){

        toast.error('Problem Validating Review: ' + error.data.errors.Message);
        //throw error;
      }
      else{

        toast.error('Problem Validating Review');
       //throw error;
      }
    }
    runInAction('ValidateReview', () => {
      toast.info('Validation processed');
    });
  };

  ContinueToRequestReview = async (Id: string) => {
    this.rootStore.modalStore.closeModal();
    this.clearRequestReviewData()
    history.push(`/RequestReview/${Id}`)
  };
  ViewReadOnlyRequestReview = async (Id: string) => {
    this.rootStore.modalStore.closeModal();
    history.push(`/RequestReview/${Id}`)
  };

  GetStep = async (step: number) => {
    var res = this.rootStore.requestReviewDocumentStore.CheckForUnAnsweredQuestions();
    if (!res) {
      toast.info("cannot continue submition process. " + this.rootStore.requestReviewDocumentStore.missingDocumentText)
    }
    else {
      if (step === 1) {
        this.validating = true;
        let result = this.rootStore.requestReviewDocumentStore.CheckDocumentsRequirementFulfilled();
        if (result[0]) {
          await this.SubmitRequestValidation();
          if (this.ValidationResult !== undefined) {
            this.rootStore.modalStore.openModal(<RequestReviewValidation />)
          }
        }
        else {
          toast.error("The following document(s) REQUIRE a Note before validating: " + result[1].join())
        }

        this.validating = false;
      }
      else if (step === 2) {

        this.rootStore.modalStore.openModal(<RequestReviewMakeDetermination />)
      }
      else if (step === 3) {
        var SelectedNoteTypes: {
          key: string;
          text: string;
          value: string;
        }[] = [];

        noteTypes.forEach(element => {
          if (this.requestResult === "Approved" || this.requestResult == "Rejected") {
            if (element.key === "Recommendation") {
              SelectedNoteTypes.push(element)
            }
          }
          if (this.requestResult === "Escalate for Additional Review") {
            if (element.key === "Escalation") {
              SelectedNoteTypes.push(element)
            }
          }
          if (this.requestResult === "DeEscalated for Additional Review") {
            if (element.key === "DeEscalation") {
              SelectedNoteTypes.push(element)
            }
          }
        });
        this.rootStore.modalStore.openModal(<RequestReviewNoteCompleteForm requestReviewId={this.RequestReview!.id} validNoteTypes={SelectedNoteTypes} />)
      }
      else if (step === 4) {
        this.rootStore.modalStore.openModal(<RequestReviewSubmitConfirmation />)
      }
    }
  }

  ClearRequestReview = () => {
    this.RequestReview = null;
  }

  setReviewResult = (dataValue: string) => {
    this.requestResult = dataValue;
  }

  setNoteResult = () => {
    this.submitedNote = true;
  }

  CompleteReview = async (escalation: string) => {
    this.submitting=true;
    const requestForm: IRequestReviewSubmitForm = new IRequestReviewSubmitForm(this.RequestReview?.id, this.requestResult, escalation);
    await this.SubmitRequestReview(requestForm);
    runInAction('createRequestReview', () => {
      this.submitting = false;
    });

    history.push('/Requests')
    toast.success('Request Has been successfully reviewed');
  }


}

decorate(RequestReviewStore, {
  RequestReviewRegistry: observable,
  RequestReview: observable,
  loadingInitial: observable,
  submitting: observable,
  validating: observable,
  target: observable,
  requestReviewCount: observable,
  page: observable,
  predicate: observable,
  availableReviewResults: observable,
  ValidationResult: observable,
  pdf: observable,
  limit: observable,
  totalPages: observable,
  sortOrder: observable,
  sortBy: observable,

  requestResult: observable,
  validatedResult: observable,
  submitedNote: observable,

  loadRequestReview: action,
  loadTableRequestReviews: action,
  loadRequestReviews: action,
  clearRequestReviews: action,
  ClearRequestReview: action,
  setPage: action,
  setLimit: action,
  createRequestReview: action,
  SubmitRequestReview: action,
  ContinueToRequestReview: action,
  setPredicate: action,
  incrementRequestReviewNote: action,
  ViewReadOnlyRequestReview: action,


  setNoteResult: action,
  setReviewResult: action,
  CompleteReview: action,

  axiosParams: computed,
  requestReviews: computed
});